import { Activity, AssetTransitDirection, Point } from "../swagger/caasService-v1";
export const GHOST_ASSET_ID = "08166b99-deea-4116-9f53-d734ee2aeb9e";
export const GHOST_CHARGE_ACTIVITIES = [
    {
        activity: "Working",
        activityEndTimeStamp: "2026-05-14T12:00:00.000",
        activityStartTimeStamp: "2026-05-14T08:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        chargeEnergy: 10,
        dischargeEnergy: 50,
        endSoc: 60,
        startSoc: 80
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-14T15:00:00.000",
        activityStartTimeStamp: "2026-05-14T13:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        chargeEnergy: 30,
        dischargeEnergy: 0,
        endSoc: 90,
        startSoc: 60
    },
    {
        activity: "Working",
        activityEndTimeStamp: "2026-05-14T18:00:00.000",
        activityStartTimeStamp: "2026-05-14T15:30:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        chargeEnergy: 0,
        dischargeEnergy: 35,
        endSoc: 55,
        startSoc: 90
    }
];
export const GHOST_ASSET_ENTRIES = [
    {
        activity: Activity.CHARGING,
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: "Unknown",
        assetName: "Unknown Machine #1",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: "GHOST",
        capacity: 0,
        location: {
            lastReportedTime: new Date().toISOString().replace("Z", ""),
            position: { coordinates: [51.817833, 5.3473053], type: Point.type.POINT },
            streetAddress: "Gemeneweg 4, 4063 CT Heesselt, Netherlands"
        },
        soc: 98,
        timestamp: new Date().toISOString().replace("Z", "")
    },
    {
        activity: Activity.UNKNOWN,
        assetId: "08266b99-deea-4116-9f53-d734ee2aeb9e",
        assetIdentifierStatus: "Unknown",
        assetName: "Unknown Machine #2",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08266b99",
        assetSourceType: "GHOST",
        capacity: 0,
        soc: 28,
        timestamp: "2026-05-11T22:30:00.000"
    }
];
export const GHOST_NETWORK_ENTRIES = [
    {
        activity: Activity.CHARGING,
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "Unknown Machine #1",
        assetSerialNumber: "Unknown machine",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: "GHOST",
        assetTransitDirection: AssetTransitDirection.AT_SITE,
        chargingSource: "2df4eec8-0b7d-464c-9fef-715a29dcbf68",
        location: {
            lastReportedTime: "2026-05-13T23:02:00.000",
            position: { coordinates: [-87.82324, 42.88285], type: Point.type.POINT },
            streetAddress: "Tweede Nassaustraat 23, 1052 BK Amsterdam, Netherlands"
        },
        soc: 100,
        timestamp: "2026-05-13T23:02:00.000"
    }
];
export const GHOST_TIMELINE_ENTRIES = [
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-14T15:55:00.000",
        activityStartTimeStamp: "2026-05-14T12:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "Unknown Machine #1",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: "GHOST",
        assetTransitDirection: "AtSite",
        chargeEnergy: 5543,
        endSoc: 85,
        startSoc: 23
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-14T06:00:00.000",
        activityStartTimeStamp: "2026-05-14T00:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "Unknown Machine #1",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: "GHOST",
        chargeEnergy: 11.0
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-14T12:00:00.000",
        activityStartTimeStamp: "2026-05-14T08:30:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "HDD0001",
        assetSourceId: "HDD0001",
        assetSourceType: "CHARGER",
        assetTransitDirection: "AtSite",
        chargeEnergy: 242,
        connectorId: "1"
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-14T08:30:00.000",
        activityStartTimeStamp: "2026-05-14T04:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "HDD0001",
        assetSourceId: "HDD0001",
        assetSourceType: "CHARGER",
        chargeEnergy: 242,
        connectorId: "2"
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-14T04:00:00.000",
        activityStartTimeStamp: "2026-05-13T22:30:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "E-NOMAD_01",
        assetSourceId: "CPG0001",
        assetSourceType: "ENERGY_SOURCE",
        assetStatus: "Charging",
        chargeEnergy: 242,
        connectorId: "2"
    }
];
export const GHOST_TIMELINE_ENTRIES_PAGE_2 = [
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-13T22:30:00.000",
        activityStartTimeStamp: "2026-05-13T18:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "Unknown Machine #1",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: "GHOST",
        assetTransitDirection: "AtSite",
        chargeEnergy: 3200,
        endSoc: 70,
        startSoc: 30
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-13T18:00:00.000",
        activityStartTimeStamp: "2026-05-13T14:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "HDD0001",
        assetSourceId: "HDD0001",
        assetSourceType: "CHARGER",
        assetTransitDirection: "AtSite",
        chargeEnergy: 180,
        connectorId: "1"
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-13T14:00:00.000",
        activityStartTimeStamp: "2026-05-13T10:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "Unknown Machine #1",
        assetSourceId: "GHOST-08166b99",
        assetSourceType: "GHOST",
        chargeEnergy: 4100,
        endSoc: 95,
        startSoc: 45
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-13T10:00:00.000",
        activityStartTimeStamp: "2026-05-13T06:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "E-NOMAD_01",
        assetSourceId: "CPG0001",
        assetSourceType: "ENERGY_SOURCE",
        assetStatus: "Charging",
        chargeEnergy: 310,
        connectorId: "1"
    },
    {
        activity: "Charging",
        activityEndTimeStamp: "2026-05-13T06:00:00.000",
        activityStartTimeStamp: "2026-05-13T00:00:00.000",
        assetId: "08166b99-deea-4116-9f53-d734ee2aeb9e",
        assetName: "HDD0001",
        assetSourceId: "HDD0001",
        assetSourceType: "CHARGER",
        chargeEnergy: 275,
        connectorId: "2"
    }
];
export const GHOST_ENERGY_STAT_ENTRIES = [
    {
        endTimestamp: "2026-05-28T23:59:59.000",
        energyDetails: { chargeEnergy: { unitOfMeasure: "kWh", value: 600 } },
        startTimestamp: "2026-05-28T00:00:00.000"
    },
    {
        endTimestamp: "2026-05-29T23:59:59.000",
        energyDetails: { chargeEnergy: { unitOfMeasure: "kWh", value: 800 } },
        startTimestamp: "2026-05-29T00:00:00.000"
    },
    {
        endTimestamp: "2026-05-30T23:59:59.000",
        energyDetails: { chargeEnergy: { unitOfMeasure: "kWh", value: 1200 } },
        startTimestamp: "2026-05-30T00:00:00.000"
    },
    {
        endTimestamp: "2026-05-31T23:59:59.000",
        energyDetails: { chargeEnergy: { unitOfMeasure: "kWh", value: 1100 } },
        startTimestamp: "2026-05-31T00:00:00.000"
    },
    {
        endTimestamp: "2026-06-01T23:59:59.000",
        energyDetails: { chargeEnergy: { unitOfMeasure: "kWh", value: 200 } },
        startTimestamp: "2026-06-01T00:00:00.000"
    },
    {
        endTimestamp: "2026-06-02T23:59:59.000",
        energyDetails: { chargeEnergy: { unitOfMeasure: "kWh", value: 1000 } },
        startTimestamp: "2026-06-02T00:00:00.000"
    },
    {
        endTimestamp: "2026-06-03T23:59:59.000",
        energyDetails: { chargeEnergy: { unitOfMeasure: "kWh", value: 1200 } },
        startTimestamp: "2026-06-03T00:00:00.000"
    }
];
export const GHOST_STATUS_HISTORY_ENTRIES = [
    { assetStatus: "Charging", duration: 6.0, unitOfMeasure: "hours" },
    { assetStatus: "Charging", duration: 5.3, unitOfMeasure: "hours" },
    { assetStatus: "Charging", duration: 0.0, unitOfMeasure: "hours" },
    { assetStatus: "Charging", duration: 10.3, unitOfMeasure: "hours" }
];
